import { theme } from 'styles';

export const defaultStyles = {
  '& .MuiSelect-select.MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    fontWeight: 500,

    '&:focus': {
      background: 'none',
    },
  },

  '& .MuiSelect-icon': {
    fontSize: '22px',
    right: '8px',
    color: theme.palette.primary.p080,
  },
};

export const defaultMobileStyles = {
  '& .MuiSelect-select.MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '24px',

    '&:focus': {
      background: 'none',
    },
  },

  '& .MuiSelect-icon': {
    fontSize: '24px',
    right: '10px',
    color: theme.palette.primary.p030,
  },
};

export const menuItemStyles = {
  fontSize: '14px',
  width: '250px',
};

export const menuSelectedItemStyles = {
  fontSize: '14px',
  width: '250px',
  backgroundColor: theme.palette.info.p030,
};
